import React from 'react';
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Switch,
  Typography,
} from '@material-ui/core';

const FilterBar = ({ filters, onChange, onReset }) => (
  <Paper
    elevation={0}
    style={{
      padding: '1rem 1rem 0.9rem',
      marginBottom: '1rem',
      border: '1px solid rgba(169, 144, 124, 0.28)',
      borderRadius: 16,
      background: 'linear-gradient(180deg, #fffcf7 0%, #f9f1e7 100%)',
    }}
  >
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
      <Typography variant="subtitle1" style={{ fontWeight: 800 }}>Filters</Typography>
      {onReset && (
        <Button size="small" color="primary" onClick={onReset}>
          Reset
        </Button>
      )}
    </Box>
    <Box display="grid" gridGap={12}>
      <FormControl variant="outlined" size="small">
        <InputLabel id="type-label">Type</InputLabel>
        <Select
          labelId="type-label"
          value={filters.type}
          onChange={(event) => onChange('type', event.target.value)}
          label="Type"
        >
          <MenuItem value="restaurants">Restaurants</MenuItem>
          <MenuItem value="hotels">Hotels</MenuItem>
          <MenuItem value="attractions">Attractions</MenuItem>
        </Select>
      </FormControl>

      <FormControl variant="outlined" size="small">
        <InputLabel id="rating-label">Min rating</InputLabel>
        <Select
          labelId="rating-label"
          value={filters.rating}
          onChange={(event) => onChange('rating', event.target.value)}
          label="Min rating"
        >
          <MenuItem value="0">All</MenuItem>
          <MenuItem value="3">3.0+</MenuItem>
          <MenuItem value="4">4.0+</MenuItem>
          <MenuItem value="4.5">4.5+</MenuItem>
        </Select>
      </FormControl>

      <FormControl variant="outlined" size="small">
        <InputLabel id="price-label">Price</InputLabel>
        <Select
          labelId="price-label"
          value={filters.priceLevel}
          onChange={(event) => onChange('priceLevel', event.target.value)}
          label="Price"
        >
          <MenuItem value="any">Any</MenuItem>
          <MenuItem value="$">$</MenuItem>
          <MenuItem value="$$ - $$$">$$ - $$$</MenuItem>
          <MenuItem value="$$$$">$$$$</MenuItem>
        </Select>
      </FormControl>

      <FormControl variant="outlined" size="small">
        <InputLabel id="distance-label">Distance</InputLabel>
        <Select
          labelId="distance-label"
          value={filters.distanceKm}
          onChange={(event) => onChange('distanceKm', event.target.value)}
          label="Distance"
        >
          <MenuItem value="0">Any</MenuItem>
          <MenuItem value="2">Within 2 km</MenuItem>
          <MenuItem value="5">Within 5 km</MenuItem>
          <MenuItem value="10">Within 10 km</MenuItem>
        </Select>
      </FormControl>

      <FormControl variant="outlined" size="small">
        <InputLabel id="sort-label">Sort by</InputLabel>
        <Select
          labelId="sort-label"
          value={filters.sortBy}
          onChange={(event) => onChange('sortBy', event.target.value)}
          label="Sort by"
        >
          <MenuItem value="relevance">Relevance</MenuItem>
          <MenuItem value="rating">Rating</MenuItem>
          <MenuItem value="reviews">Reviews</MenuItem>
        </Select>
      </FormControl>

      <FormControlLabel
        control={(
          <Switch
            color="primary"
            checked={Boolean(filters.openNow)}
            onChange={(event) => onChange('openNow', event.target.checked)}
          />
        )}
        label="Open now"
      />
    </Box>
  </Paper>
);

export default FilterBar;
